import { auth } from "../firebase";

const API = process.env.REACT_APP_API_BASE || "http://localhost:8080";

async function getAuthHeaders() {
  const u = auth.currentUser;
  if (!u) return {}; // буде 401 — це ок, якщо юзер не залогінений
  const token = await u.getIdToken(true); // true = форс-рефреш (на старті дуже допомагає)
  return { Authorization: `Bearer ${token}` };
}

async function getJson(url, opts = {}) {
  const headers = {
    ...(opts.headers || {}),
    ...(await getAuthHeaders()),
  };

  const res = await fetch(url, { ...opts, headers });
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    // щоб одразу бачити реальну причину
    console.warn("API error:", res.status, url, data);
    throw new Error(data?.error || data?.message || `HTTP ${res.status}`);
  }

  return data;
}

export async function getMyAccountData() {
  const [ch, pu] = await Promise.all([
    getJson(`${API}/me/chats`),
    getJson(`${API}/me/purchases`),
  ]);

  return {
    chats: ch.chats || [],
    purchases: pu.purchases || [],
  };
}
